import './App.css';
import AppRouter from './AppRouter';

function App() {
  return (
    <div className="app">
      <AppRouter />
    </div>
  );
}

export default App;
